import { DateTime } from 'luxon'

type DateTimeFormat = 'ISO8601' | string

const formatDate = (
  dateString: string | null | undefined,
  currentFormat: DateTimeFormat,
  exportFormat: DateTimeFormat = 'yyyy-MM-dd',
): string => {
  if (!dateString){
    return ''
  }

  let date: DateTime

  if (currentFormat === 'ISO8601'){
    date = DateTime.fromISO(dateString)
  } else {
    date = DateTime.fromFormat(dateString, currentFormat)
  }

  if (!date.isValid){
    return ''
  }

  if (exportFormat === 'ISO8601'){
    return date.toISO() ?? ''
  }

  return date.toFormat(exportFormat)
}

export default formatDate
